export const INVALIDATE_USERS = "Users";
export const INVALIDATE_HOTELIERS = "Hoteliers";
export const INVALIDATE_HOTEL = "Hotel";
